
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Topcarrentalcompanyinpune() {



    const cardData =
    {
        keyword: 'Top Car Rental Company in Pune',
        heading: 'etravo : Top Car Rental Company in Pune',



"headingDescription": "eTravo is a trusted Car Rental Company in Pune, offering reliable and comfortable transportation solutions for business travel, airport transfers, corporate transportation, family trips, weddings, and outstation journeys. With a wide range of well-maintained cars, professional chauffeurs, and flexible rental options, eTravo makes it easy to book a car for short trips, full-day travel, or longer journeys. Whether you need a car for corporate travel, local sightseeing, airport pickup, or an outstation trip, eTravo provides convenient and dependable car rental services in Pune to suit your travel needs.",

"top": "Top Car Rental Companies & Service Zones in Pune with eTravo",

"topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "Pune’s largest IT hub with global tech companies, requiring reliable corporate car rental and employee transportation services."
  },
  {
    "title": "Kharadi IT Park",
    "description": "A rapidly growing business district with EON IT Park and World Trade Center, making it a key demand zone for car rental services."
  },
  {
    "title": "Magarpatta City",
    "description": "A major IT township with Cybercity offices, ideal for structured corporate travel and daily commute rentals."
  },
  {
    "title": "Hadapsar",
    "description": "An important commercial and IT zone with SP Infocity and multiple corporate offices requiring dependable transport services."
  },
  {
    "title": "Baner-Balewadi",
    "description": "A fast-developing corporate and startup hub with high demand for flexible car rental and business travel solutions."
  },
  {
    "title": "Viman Nagar",
    "description": "A premium business and residential area near Pune Airport, widely used for executive travel and airport transfers."
  },
  {
    "title": "Koregaon Park",
    "description": "A high-end locality with corporate offices, consulting firms, and luxury hotels requiring premium car rental services."
  },
  {
    "title": "Wakad",
    "description": "A major residential hub for IT professionals working in Hinjewadi, requiring daily and monthly car rental services."
  },
  {
    "title": "Shivajinagar",
    "description": "A central business district with government and corporate offices, making it a key mobility and rental service zone."
  },
  {
    "title": "Pimpri-Chinchwad",
    "description": "A large industrial and commercial hub with manufacturing companies and corporate offices needing workforce transportation and rental services."
  }
],


"services": [
{
"name": "Top Car Rental Pune",
"description": "eTravo stands as a top car rental service in Pune, offering reliable and comfortable transportation for all travel needs. Whether it’s corporate travel, airport transfers, or daily commutes, our service ensures punctuality and professionalism."
},
{
"name": "Best Car Rental Company Pune",
"description": "Recognized as one of the best car rental companies in Pune, eTravo provides well-maintained vehicles and experienced drivers. Our focus on quality service and customer satisfaction makes us a preferred choice."
},
{
"name": "Leading Car Hire Pune",
"description": "eTravo is a leading car hire provider in Pune offering flexible and dependable transportation solutions. Our services cater to both individuals and businesses with a strong emphasis on comfort and reliability."
},
{
"name": "Professional Car Rental Pune",
"description": "Our professional car rental services in Pune are designed to meet high standards of quality and efficiency. eTravo ensures clean vehicles, trained chauffeurs, and a smooth travel experience."
},
{
"name": "Trusted Car Rental Pune",
"description": "eTravo is a trusted car rental provider in Pune known for its consistent and reliable service. We ensure safe, timely, and comfortable travel for all customers."
},
{
"name": "Top Cab Service Pune",
"description": "eTravo offers top cab services in Pune for daily commuting and business travel. Our cabs provide comfort, punctuality, and a hassle-free travel experience."
},
{
"name": "Best Taxi Provider Pune",
"description": "As a leading taxi provider in Pune, eTravo ensures high-quality service with well-maintained vehicles and professional drivers. Our taxis are ideal for both local and outstation travel."
},
{
"name": "Car Rental Services Pune",
"description": "eTravo provides comprehensive car rental services in Pune for all types of travel needs. From short trips to long journeys, our service ensures reliability and convenience."
},
{
"name": "Premium Car Rental Pune",
"description": "Experience luxury and comfort with eTravo’s premium car rental services in Pune. Our fleet includes executive vehicles designed for high-end travel and corporate requirements."
},
{
"name": "Reliable Car Hire Pune",
"description": "eTravo offers reliable car hire services in Pune with a focus on punctuality and safety. Our vehicles and drivers ensure a smooth and comfortable travel experience."
},
{
"name": "Top Vehicle Rental Pune",
"description": "Our top vehicle rental services in Pune provide a wide range of options for different travel needs. eTravo ensures quality vehicles and dependable service for every journey."
},
{
"name": "Car Rental Agency Pune",
"description": "eTravo is a professional car rental agency in Pune offering flexible and efficient travel solutions. We provide well-maintained vehicles and seamless booking experiences."
},
{
"name": "Best Travel Cars Pune",
"description": "eTravo offers the best travel cars in Pune for comfortable and hassle-free journeys. Our vehicles are ideal for both local and outstation trips with a focus on customer satisfaction."
},
{
"name": "Leading Taxi Service Pune",
"description": "As a leading taxi service provider in Pune, eTravo ensures reliable and efficient travel solutions. Our service is designed to meet the needs of both individuals and businesses."
},
{
"name": "Top Fleet Service Pune",
"description": "eTravo provides top fleet services in Pune for businesses requiring multiple vehicles. Our fleet solutions ensure consistent quality, availability, and professional service."
}
],
"tableData": [
["Top Car Rental Pune", "Best Car Rental Company Pune"],
["Leading Car Hire Pune", "Professional Car Rental Pune"],
["Trusted Car Rental Pune", "Top Cab Service Pune"],
["Best Taxi Provider Pune", "Car Rental Services Pune"],
["Premium Car Rental Pune", "Reliable Car Hire Pune"],
["Top Vehicle Rental Pune", "Car Rental Agency Pune"],
["Best Travel Cars Pune", "Leading Taxi Service Pune"],
["Top Fleet Service Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Top Car Rental Company in Pune for Corporate Travel",
      "WhyChoosedescription": "eTravo is recognized as a top car rental company in Pune, offering reliable, professional, and scalable transportation solutions for corporate clients, businesses, and daily commuters."
    },
    {
      "WhyChooseheading": "Extensive Fleet for Every Travel Requirement",
      "WhyChoosedescription": "Our fleet includes hatchbacks, sedans, SUVs, and luxury vehicles, ensuring the perfect option for employee transport, executive travel, and outstation trips."
    },
    {
      "WhyChooseheading": "Punctual and Reliable Cab Services",
      "WhyChoosedescription": "We prioritize on-time service for all bookings, ensuring timely pickups and drop-offs for corporate meetings, airport transfers, and daily commuting needs."
    },
    {
      "WhyChooseheading": "Experienced and Professional Chauffeurs",
      "WhyChoosedescription": "Our trained drivers maintain high standards of safety, professionalism, and customer service, delivering a smooth and comfortable travel experience."
    },
    {
      "WhyChooseheading": "Flexible Rental Options for Businesses",
      "WhyChoosedescription": "eTravo offers hourly, daily, monthly, and long-term rental plans, allowing businesses and individuals to choose services that match their exact travel requirements."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "We provide clear pricing structures with GST-compliant billing, ensuring complete transparency and easy expense management for corporate clients."
    },
    {
      "WhyChooseheading": "Safe, Clean, and Well-Maintained Vehicles",
      "WhyChoosedescription": "All vehicles are regularly serviced and sanitized to ensure maximum safety, hygiene, and comfort for every journey."
    },
    {
      "WhyChooseheading": "24/7 Customer Support and Booking Assistance",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, changes, and urgent travel needs."
    }
  ]

}

const faqData = [
    [
        {
            question: 'Which is the top car rental company in Pune?',
            answer: 'Top car rental companies in Pune offer reliable service, a wide fleet, professional drivers, and flexible booking options for corporate and personal travel.',
        },
        {
            question: 'What services do car rental companies in Pune provide?',
            answer: 'They provide local travel, airport transfers, corporate cab services, outstation trips, and long-term rental solutions.',
        },
        {
            question: 'Can I book a car rental in Pune for corporate use?',
            answer: 'Yes, many companies like eTravo specialize in corporate car rental services including employee transport and executive travel.',
        },
        {
            question: 'What types of vehicles are available for rental in Pune?',
            answer: 'You can choose from hatchbacks, sedans, SUVs, luxury cars, and tempo travellers depending on your travel needs.',
        },
        {
            question: 'Are car rental services in Pune available 24/7?',
            answer: 'Yes, most professional car rental companies operate 24/7 to support business and personal travel requirements.',
        },
        {
            question: 'Is it safe to book a cab from a car rental company in Pune?',
            answer: 'Yes, trusted companies provide verified drivers, GPS tracking, and well-maintained vehicles for safe travel.',
        },
        {
            question: 'Do car rental companies provide airport transfer services?',
            answer: 'Yes, airport pickup and drop services are commonly offered for both individuals and corporate clients.',
        },
        {
            question: 'Can I book a car for outstation travel from Pune?',
            answer: 'Yes, car rental companies provide one-way, round-trip, and multi-day outstation travel services.',
        },
        {
            question: 'Do car rental services offer monthly plans?',
            answer: 'Yes, many providers offer cost-effective monthly rental plans for corporate and regular users.',
        },
        {
            question: 'How can I book a top car rental service in Pune?',
            answer: 'You can book online through the company website or contact their support team for quick and easy booking.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Kulkarni',
        designation: 'Operations Manager, Corporate Firm, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo is one of the top car rental companies in Pune. Their punctual service and professional drivers make corporate travel smooth and reliable.”',
    },
    {
        name: 'Ms. Sneha Deshpande',
        designation: 'HR Manager, IT Company, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo regularly for employee transport. Their flexible plans and well-maintained vehicles make them the best choice for corporate travel.”',
    },
];










    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Car Rental Services in Pune",
  "serviceType": "Car Rental Service",
  "description":
    "eTravo provides reliable car rental services in Pune for business travel, airport transfers, corporate transportation, family trips, weddings, local travel, and outstation journeys.",
  "provider": {
    "@type": "Organization",
    "name": "eTravo",
    "url": "https://www.etravo.in/"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "url": "https://www.etravo.in/top-car-rental-company-in-pune"
};







    return (
        <div>

<Helmet>
  <title>
    Top Car Rental Company in Pune | Car Hire & Rental Services | eTravo
  </title>

  <meta
    name="description"
    content="Looking for a reliable car rental company in Pune? eTravo offers car hire with chauffeur services for business travel, airport transfers, weddings, local and outstation trips."
  />

  <meta
    name="keywords"
    content="top car rental company in Pune, car rental company in Pune, car rental Pune, car hire Pune, car rental services Pune, chauffeur car rental Pune, outstation car rental Pune"
  />

  <link
    rel="canonical"
    href="https://www.etravo.in/top-car-rental-company-in-pune"
  />

  <meta
    name="robots"
    content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Top Car Rental Company in Pune | Car Hire & Rental Services | eTravo"
  />

  <meta
    property="og:description"
    content="Book reliable car rental services in Pune with eTravo for business travel, airport transfers, weddings, local trips and outstation journeys."
  />

  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:url"
    content="https://www.etravo.in/top-car-rental-company-in-pune"
  />

  <meta
    property="og:image"
    content="https://www.etravo.in/images/keyword/top-car-rental-company-in-pune.jpg"
  />

  <meta
    property="og:image:alt"
    content="Top car rental company in Pune"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Top Car Rental Company in Pune | eTravo"
  />

  <meta
    name="twitter:description"
    content="Explore reliable car rental and chauffeur-driven car hire services in Pune with eTravo for business, airport, wedding and outstation travel."
  />

  <meta
    name="twitter:image"
    content="https://www.etravo.in/images/keyword/top-car-rental-company-in-pune.jpg"
  />

  {/* Schema */}
  <script type="application/ld+json">
    {JSON.stringify(serviceSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/top-car-rental-company-in-pune.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Topcarrentalcompanyinpune;